import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  GET_INBOX_MAILS,
  SEND_MAIL_TO_USER,
  SET_MAIL_READ,
  GET_IMPORTANT_MAILS,
  GET_DRAFT_MAILS,
  GET_SENT_MAILS,
  GET_PARTICIPANT_EMAILS,
  REPLY_TO_EMAIL,
  ADD_EMAIL_SIGN,
  FREE_EMAIL_NOTIFICATIONS,
  GET_STORED_EMAILS,
  GET_ADDRESS_BOOK,
  REMOVE_ADDRESS_BOOK_EMAIL,
} from "./actionTypes";

import {
  getInboxMailsSuccess,
  getInboxMailsFail,
  sendMailForUserFail,
  sendMailForUserSuccess,
  setMailReadSuccess,
  setMailReadFail,
  getImportantMailsSuccess,
  getImportantMailsFail,
  getDraftMailsSuccess,
  getDraftMailsFail,
  getSentMailsSuccess,
  getSentMailsFail,
  getParticipantEmailSuccess,
  getParticipantEmailFail,
  replyToEmailSuccess,
  replyToEmailFail,
  addEmailSignSuccess,
  addEmailSignFail,
  freeEmailNotificationSuccess,
  freeEmailNotificationFail,
  getStoredEmailsSuccess,
  getStoredEmailsFail,
  getAddressBookListFail,
  getAddressBookListSuccess,
  removeEmailSuccess,
  removeEmailFail,
} from "./actions";

//Include Both Helper File with needed methods
import {
  getInboxMails,
  sendEmailToUser,
  onReadMail,
  getImportantMails,
  getDraftMails,
  getSentMails,
  fetchParticipantMails,
  replyEmailToUser,
  onAddingEmailSign,
  onFreeEmailNotification,
  onGetStoredEmails,
  onGettingAddressBookList,
  onRemovingEmail,
} from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { showNotifications } from "common/ApiCalls";
import { responseHandler } from "common/CommanFunction";

function* StoredEmails({ payload: data }) {
  try {
    const response = yield call(onGetStoredEmails, data);
    yield put(getStoredEmailsSuccess(response));
  } catch (error) {
    showToast("error", "Stored Emails", error);
    yield put(getStoredEmailsFail(error));
  }
}

function* fetchInboxMails({ payload: data }) {
  try {
    const response = yield call(getInboxMails, data);
    yield put(getInboxMailsSuccess(response));
  } catch (error) {
    showToast("error", "Email List", error);
    yield put(getInboxMailsFail(error));
  }
}

function* ReadMail({ payload: data }) {
  try {
    const response = yield call(onReadMail, data);
    yield put(setMailReadSuccess(response));
  } catch (error) {
    showToast("error", "Email List", error);
    yield put(setMailReadFail(error));
  }
}

function* Free_Email_Notification({ payload: { data, dispatch } }) {
  try {
    const response = yield call(onFreeEmailNotification, data);
    yield put(freeEmailNotificationSuccess(response));
    showNotifications(dispatch);
  } catch (error) {
    showToast("error", "Email Notification", error);
    yield put(freeEmailNotificationFail(error));
  }
}

function* fetchImportantMails() {
  try {
    const response = yield call(getImportantMails);
    yield put(getImportantMailsSuccess(response));
  } catch (error) {
    yield put(getImportantMailsFail(error));
  }
}

function* fetchDraftMails() {
  try {
    const response = yield call(getDraftMails);
    yield put(getDraftMailsSuccess(response));
  } catch (error) {
    yield put(getDraftMailsFail(error));
  }
}

function* fetchSentMails() {
  try {
    const response = yield call(getSentMails);
    yield put(getSentMailsSuccess(response));
  } catch (error) {
    yield put(getSentMailsFail(error));
  }
}

function* fetchParticipantEmails({ payload: data }) {
  try {
    const response = yield call(fetchParticipantMails, data);
    yield put(getParticipantEmailSuccess(response));
  } catch (error) {
    yield put(getParticipantEmailFail(error));
  }
}

function* onSendEmail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(sendEmailToUser, data);
    yield call(responseHandler, "Sending Email", response, sendMailForUserSuccess, sendMailForUserFail, onSuccess, onError);
  } catch (error) {
    onError();
    showToast("error", "Sending Email", error);
    yield put(sendMailForUserFail(error));
  }
}

function* onAddEmailSign({ payload: data }) {
  try {
    const response = yield call(onAddingEmailSign, data);
    yield put(addEmailSignSuccess(response));
    if (response.status) {
      showToast("success", "Email Signature", response.message);
    } else {
      showToast("warning", "Email Signature", response.message);
    }
  } catch (error) {
    showToast("error", "Email Signature", error);
    yield put(addEmailSignFail(error));
  }
}

function* onReplyEmail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(replyEmailToUser, data);
    yield call(responseHandler, "Replying Email", response, replyToEmailSuccess, replyToEmailFail, onSuccess, onError);
  } catch (error) {
    onError();
    showToast("error", "Sending Email", error);
    yield put(replyToEmailFail(error));
  }
}

function* onGetAddressBookList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingAddressBookList, data);
    yield call(responseHandler, "Address Book", response, getAddressBookListSuccess, getAddressBookListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    showToast("error", "Address Book", error);
    yield put(getAddressBookListFail(error));
  }
}

function* onRemoveEmail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRemovingEmail, data);
    yield call(responseHandler, "Address Book", response, removeEmailSuccess, removeEmailFail, onSuccess, onError);
  } catch (error) {
    onError();
    showToast("error", "Address Book", error);
    yield put(removeEmailFail(error));
  }
}

function* mailsSaga() {
  yield takeEvery(GET_INBOX_MAILS, fetchInboxMails);
  yield takeEvery(SET_MAIL_READ, ReadMail);
  yield takeEvery(GET_IMPORTANT_MAILS, fetchImportantMails);
  yield takeEvery(GET_DRAFT_MAILS, fetchDraftMails);
  yield takeEvery(GET_SENT_MAILS, fetchSentMails);
  yield takeEvery(GET_PARTICIPANT_EMAILS, fetchParticipantEmails);
  yield takeEvery(SEND_MAIL_TO_USER, onSendEmail);
  yield takeEvery(REPLY_TO_EMAIL, onReplyEmail);
  yield takeEvery(ADD_EMAIL_SIGN, onAddEmailSign);
  yield takeEvery(FREE_EMAIL_NOTIFICATIONS, Free_Email_Notification);
  yield takeEvery(GET_STORED_EMAILS, StoredEmails);
  yield takeEvery(GET_ADDRESS_BOOK, onGetAddressBookList);
  yield takeEvery(REMOVE_ADDRESS_BOOK_EMAIL, onRemoveEmail);
}

export default mailsSaga;
